// assets
import { FireOutlined, AimOutlined, SecurityScanOutlined } from "@ant-design/icons";
import Permissions from "constants/Permissions";

// ==============================|| MENU ITEMS - ARIAL AWARENESS ||============================== //

const arial_awareness = {
    id: "group-arial-awareness",
    title: "Arial Awareness",
    type: "group",
    appModule: "ARIAL_AWARENESS",
    children: [
        {
            id: "shelling",
            title: "Shellings",
            authority: Permissions.ShellingSection.Shelling,
            type: "item",
            url: "/shelling",
            icon: FireOutlined,
            breadcrumbs: false,
        },
        {
            id: "fire-damage",
            title: "Fire Damage",
            authority: Permissions.FireDamageSection.FireDamage,
            type: "item",
            url: "/fire-damage",
            icon: AimOutlined,
            breadcrumbs: false,
        },
        {
            id: "military-surveillance",
            title: "Military Surveillance",
            authority: Permissions.MilitarySurveillanceSection.MilitarySurveillance,
            type: "item",
            url: "/military-surveillance",
            icon: SecurityScanOutlined,
            breadcrumbs: false,
        },
    ],
};

export default arial_awareness;
